module.exports = __webpack_public_path__ + "static/media/calendar-feature.4e611853.png";